// vue3-migration -- Element
import langFr from 'element-plus/es/locale/lang/fr';
import translations from './translations.json';
import 'moment/locale/fr';

export default {
  ...translations,
  // vue3-migration -- Element
  ...langFr,
};
